/** The learner's private notebook — typed notes, scoped server-side to the
 *  signed-in user. The backend refuses anyone else's note with a 404, so the
 *  UI never needs to reason about ownership. */
import { request } from "./http";

export interface Note {
  id: string;
  content: string;
  created_at: string;
  updated_at: string | null;
}

export function listNotes(): Promise<Note[]> {
  return request<Note[]>("/notebook/");
}

export function createNote(content: string): Promise<Note> {
  return request<Note>("/notebook/", { method: "POST", body: { content } });
}

export function updateNote(id: string, content: string): Promise<Note> {
  return request<Note>(`/notebook/${id}`, { method: "PATCH", body: { content } });
}

export function deleteNote(id: string): Promise<void> {
  return request<void>(`/notebook/${id}`, { method: "DELETE" });
}
